import { Component, OnInit, Input, AfterViewInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../service/http.service';
import { Router, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import {
  FacebookService, LoginResponse, LoginOptions, UIResponse,
  UIParams, FBVideoComponent
} from 'ngx-facebook';
import { FormBuilder, FormGroup, FormControl, Validator, Validators } from '@angular/forms';
import { UserService } from '../../service/user.service';
import { eventEmitterService } from '../../service/eventEmitter.service';
import { isNullOrUndefined } from 'util';
import { BuildingsService } from '../../service/buildings.service';
import { PostFilterService } from '../../service/post-filter.service';
import { UserInfoService } from '../../service/user-info.service';
import { UpgradeService } from '../../service/upgrade.service';
import * as _ from 'lodash';
import { timer } from 'rxjs';
import { map } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, AfterViewInit {

  user: any;
  isAuthenticated = false;
  apiUrl = environment.apiUrl;
  clientUrl = environment.clientUrl;
  s3apiUrl = environment.s3BucketApi;
  id = localStorage.getItem('residents');
  isManager = localStorage.getItem('isManager');
  userBuildingId = localStorage.getItem('userBuildingId');
  currentBuildingMaintenanceActive = localStorage.getItem('currentBuildingMaintenanceActive') == 'true';
  isManagerStatus = false;

  fbookFriends = [];
  invite: FormGroup;
  emailError = false;
  emailFormatError = false;
  successMsg = '';
  totalGroupMsg = 0;
  timer;
  screenSize;
  profileImage = null;

  unreadAlert = 0;
  oldUnreadAlert = 0;
  totalMsg = 0;
  alertList = [];
  isInviteContentChange = false;
  postToShare = null;
  link;
  headerBar = true;
  buildings;
  finalBuilding;
  alert;

  @ViewChild('inviteMembers', { static: false })
  public invitationMail: ElementRef;

  items: string[] = ['AngularJS', 'Angluar2'];

  constructor(private httpService: HttpService,
    private fbook: FacebookService,
    private fb: FormBuilder,
    private router: Router,
    private userService: UserService,
    private buildingService: BuildingsService,
    private postFilter: PostFilterService,
    private eventService: eventEmitterService,
    private route: ActivatedRoute,
    private ngZone: NgZone, private userInfo: UserInfoService,
    private upgradeService: UpgradeService) {

    fbook.init(environment.facebook);
  }


  ngOnInit() {
   this.httpService.isAuthenticated().subscribe((data:any)=>{
      console.log(data, ":::::::::::::isAuthenticated")
      if(data.user){
        this.user = data.user;
        this.isAuthenticated = true;
      }
    });

    this.userInfo.isManager.subscribe((data: any) => {
      this.isManagerStatus = data;
    });

    this.userInfo.user.subscribe((data: any) => {
      // this.user = data;
      this.isAuthenticated = true;
    });
    this.id = localStorage.getItem('residents');
    // console.log('Header UserID' + this.id);
    // console.log('Header LocalUserID' + localStorage.getItem('residents'));
    if (!_.isNil(this.id)) {
      this.userService.getUserById(this.id).subscribe(data => {
        this.user = data.user;
      });
    }

    timer(1000, 2000).subscribe(i => {
      this.currentBuildingMaintenanceActive = localStorage.getItem('currentBuildingMaintenanceActive') == 'true';
    });

    this.link = this.router.url;
    if (this.link === '/pricing') {
      $('.top_fullstrip_header').addClass('pricing');
    }

    $(window).ready(function () {
      $('#bottomMenu').on('click', 'div', function () {
        $('#bottomMenu div.active').removeClass('active');
        $(this).addClass('active');
      });
      $('.main_container #sidepanel_id li').click(function () {
        if ($(window).innerWidth() < 481) {
          if (($('.main_container .side_panel').css('left')) == '-200px') {
            $('.main_container .side_panel').css({ 'left': 0, 'width': '100%' });
            $('#mobile_menu_switch1').addClass('view');
          }
          else {
            $('.main_container .side_panel').css({ 'left': '-200px', 'width': '200px' });
            $('#mobile_menu_switch1').removeClass('view');
          }
        }
        $('.main_container #mobile_menu_switch1').toggleClass('active');
      });
    });
    $(window).on('load ready resize', function () {
      this.screenSize = $(window).innerWidth();
      if (this.screenSize > 991) {
        $('.main_container .side_panel').css({ 'left': 0, 'width': 'inherit' });
        $('.main_container .side_panel').addClass('menu_text_hidden');
      } else {
        $('.main_container .side_panel').css({ 'left': '-200px', 'width': '200px' });
        $('.main_container .side_panel').removeClass('menu_text_hidden');
      }
    });
    this.eventService.alert$.subscribe((data) => {
      // console.log(data);
      if (data === 'reset') {
        setTimeout(() => {
          this.unreadAlert = 0;
          this.oldUnreadAlert = 0;
          this.alertList = [];
        }, 1000);
      }
    });

    self['io'].socket.on('activityfeed', (feeds) => {
      // console.log(feeds.data.alerts);
      if (this.isManager !== 'true' && this.id && (feeds.data && feeds.data.alerts)) {
        this.alertList.push(feeds.data.alerts);
        // console.log(this.oldUnreadAlert, this.alertList.length);
        this.unreadAlert = this.alertList.length + this.oldUnreadAlert;
        this.oldUnreadAlert = 0;
      }
    });


    $(document).ready(function () {
      $('#sendEmailInvites').attr('data-role', 'materialtags');
    });


    // this.eventService.eventEmit$
    // .subscribe(event => {
    //     if(event.totalMsg != ''){
    //       this.totalMsg = event.totalMsg;
    //     }
    // });

    this.invite = this.fb.group({
      email: ['', Validators.compose([Validators.required])],
    });

    this.eventService._msgCount$
      .subscribe(event => {
        if (event['getAllMsgCount'] >= 0) {
          this.totalMsg = event['getAllMsgCount'];
        } else if (event['getAllMsgCount'] === 0) {
          this.totalMsg = 0;
        }
        if (event['getAllGroupsCount'] >= 0) {
          this.totalGroupMsg = event['getAllGroupsCount'];
        } else if (event['getAllGroupsCount'] === 0) {
          this.totalGroupMsg = 0;
        }
      });

    this.eventService.eventEmit$.subscribe((event) => {

      if (event.replaceBuildingByRes) {
        this.httpService.isManagerExist(this.id).subscribe(
          (res) => {
            this.isManagerStatus = false;
          },
          (error) => {
            this.isManagerStatus = true;
          });
      }

      if (event.profilepictureUpdate) {
        this.profileImage = null;
        if (event.updatedUser) {
          this.user.profilePicture = event.updatedUser.user.profilePicture;
        }
      }
      if (event.headerToggle === true) {
        this.headerBar = true;
        this.isAuthenticated = event.localAuth;
      } else if (event.headerToggle === false) {
        this.headerBar = false;
        this.isAuthenticated = event.localAuth;
      }

      if (event.newProfileImage) {
        this.profileImage = event.newProfileImage;
      }

      if (event.feedShareOnMail === true) {
        $(this.invitationMail.nativeElement).find('div.materialize-tags span').remove();
        $(this.invitationMail.nativeElement).find('tag-input-form input[type=\'text\']').val('').focus();
        this.emailError = false;
        this.emailFormatError = false;
        $('#email-format-error').hide();
        this.isInviteContentChange = true;
        this.postToShare = event.feed;
        $('#invite_members_modal').modal('show');
      } else if (event.feedShareOnMail === false) {
        $(this.invitationMail.nativeElement).find('div.materialize-tags span').remove();
        $(this.invitationMail.nativeElement).find('tag-input-form input[type=\'text\']').val('').focus();
        this.emailError = false;
        this.emailFormatError = false;
        $('#email-format-error').hide();
        this.isInviteContentChange = false;
        $('#invite_members_modal').modal('show');
      }

      if (event.isHeaderToShow) {
        this.link = null;
      }
    });
    let that = this;
    $('#invite_members_modal').on('hidden.bs.modal', function () {

      that.isInviteContentChange = false;

      $(that.invitationMail.nativeElement).find('div.materialize-tags span').remove();
      $(that.invitationMail.nativeElement).find('tag-input-form input[type=\'text\']').val('').focus();
      that.emailError = false;
      that.emailFormatError = false;
      $('#email-format-error').hide();
    });

    if (this.isManager !== 'true' && this.id) {
      this.buildingService.getAllUnreadAlerts(this.id, this.userBuildingId).subscribe(
        (data) => {
          // console.log('Unread Alerts : ', data);
          let tempAlert = [];
          for (const alert of data.alerts) {
            if (alert.readBy.length <= 0 && alert.building.length > 0) {
              tempAlert.push(alert);
            }
          }
          this.oldUnreadAlert = tempAlert.length;
          this.unreadAlert = this.oldUnreadAlert;
        }
      );
    }

  }

  triggerMaintenanceFilter(postType) {
    if (!this.currentBuildingMaintenanceActive && postType == 'maintenance') {
      return false;
    }
    this.router.navigate(['feed']);
    this.postFilter.changeMessage(postType);
    this.eventService.eventEmit$.emit({ postType: postType });

  }


  modalTriggerMethod() {
    $('#loginForm').modal('show');
  }

  ngOnDestroy() {
    $('#loginForm').modal('hide');
  }


  resetUnreadAlert() {
    this.router.navigate(['/buildings', 'alerts']);
    setTimeout(() => {
      this.unreadAlert = 0;
      this.oldUnreadAlert = 0;
      this.alertList = [];
    }, 1000);
    this.eventService.alert$.next('reset');
  }

  settingsDropdown(event) {
    event.stopPropagation();
    $('.header_dropdown .dropdown').toggleClass('open');
  }

  ngAfterViewInit() {

    if (this.id) {

      this.buildingService.getAllBuildingsByUserId(this.id).subscribe(
        (buildings) => {
          // console.log(buildings.data[0].building);
          if (buildings.success) {
            this.buildings = buildings.data[0].building;
          }
        }
      );

      this.userService.getUserProfileImageByUserId(this.id).subscribe(
        (user) => {
          if (user) {
            this.profileImage = (user.profileImage && user.profileImage.split('assets').length > 1) ? this.apiUrl + user.profileImage.split('assets')[1] : (user.profileImage && user.profileImage.split('user').length > 1) ? this.s3apiUrl + user.profileImage : (user.profileImage) ? user.profileImage : null;
          }
        }
      );
    }


    $('.profile_pic img').attr('src', this.profileImage);

  }

  userLogout() {
    /*const header = new Headers();
    header.append('Content-Type', 'application/json');*/
    this.eventService.eventEmit$.next({ blockServerCalls: true });
    this.httpService.logout().pipe(map(res => res)).subscribe((res) => {
      // console.log(res);
      if (res) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/';
      }
    });
  }

  clearErrors(inviteForm) {
    this.emailError = false;
    this.emailFormatError = false;

    let valid = true;

    let inviteEmailsList = '';

    $(inviteForm).find('div.materialize-tags span.tag').each(function () {
      if ($(this).text() != '') {
        inviteEmailsList = inviteEmailsList + ',' + $(this).text();
      }
    });

    // console.log(inviteEmailsList);

    if (inviteEmailsList == '') {
      valid = false;
      this.emailError = true;
      $(inviteForm).find('div.materialize-tags input[type=\'text\']').val('').focus();
    }

    if (valid) {

      let inviteEmails = inviteEmailsList.split(',');

      let length = inviteEmails.length;

      let emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      let emailValid = true;
      for (let i = 0; i < length; i++) {
        if (!inviteEmails[i].match(emailReg)) {
          emailValid = false;
        }
      }

      if (emailValid === true) {
        this.emailFormatError = true;
      }

    }

  }

  sendInvite(value, valid, inviteForm) {

    this.emailError = false;
    let feed = null;

    if (!this.isInviteContentChange) {
      if (!this.finalBuilding) {
        this.alert = 'Please select your current residence';

        return;
      }

    }

    if (this.isInviteContentChange) {
      // console.log(this.isInviteContentChange, this.postToShare, '8787');
      let content = (this.postToShare.content) ? this.postToShare.content : (this.postToShare.eventDescription) ? this.postToShare.eventDescription : (this.postToShare.description) ? this.postToShare.description : 'mycoop';
      content = content.replace(/&nbsp;/g, '');
      let wrapper = document.createElement('div');
      wrapper.innerHTML = content;
      content = wrapper.innerText;
      if (this.postToShare.content) {
        this.postToShare.content = content;
      } else if (this.postToShare.eventDescription) {
        this.postToShare.eventDescription = content;
      } else if (this.postToShare.description) {
        this.postToShare.description = content;
      }
      feed = this.postToShare;
    }
    // this.emailFormatError = false;
    $('#email-format-error').hide();

    let emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    valid = true;

    let inviteEmailsList = '';

    if (value.email) {

      value.email.forEach(function (email) {
        inviteEmailsList = inviteEmailsList + ',' + email;
      });
      let email = $(inviteForm).find('tag-input-form input[type=\'text\']').val();
      if (email) {

        if (!email.match(emailReg)) {
          valid = false;
          $('#email-format-error').show();
        } else {
          valid = true;
          inviteEmailsList = inviteEmailsList + ',' + email;
        }
      }


      // if(inviteEmailsList == ''){
      //   valid = false;
      //   this.emailError = true;
      //   $(inviteForm).find("div.materialize-tags input[type='text']").val('').focus();
      // }

    } else {
      let email = $(inviteForm).find('tag-input-form input[type=\'text\']').val();
      if (email) {

        if (!email.match(emailReg)) {
          valid = false;
          $('#email-format-error').show();
        } else {
          valid = true;
          inviteEmailsList = ',' + email;
        }
      } else {
        valid = false;
        this.emailError = true;
      }

    }

    if (valid) {
      inviteEmailsList = inviteEmailsList.substring(1);

      let inviteEmails = inviteEmailsList.split(',');

      let length = inviteEmails.length;

      let emailValid = true;
      for (let i = 0; i < length; i++) {
        if (!inviteEmails[i].match(emailReg)) {
          emailValid = false;
          $('#email-format-error').show();
        }
      }

      // console.log(inviteEmails);

      if (emailValid === true) {

        this.userService.sendEmailInvite(inviteEmails, feed, this.finalBuilding).subscribe((res) => {
          if (res) {
            if (res.success === true) {
              this.successMsg = res.message;
              this.finalBuilding = null;
              setTimeout(() => {
                $('#invite_members_modal').modal('hide');
              }, 5000);

              setTimeout(() => {
                this.successMsg = '';
                $(inviteForm).find('div.materialize-tags span').remove();
                $(inviteForm).find('tag-input-form input[type=\'text\']').val('').focus();
                inviteForm.reset();
                // $('#invite_members_modal').toggle();
              }, 3000);
            }
          }
        });

      } else {
        // this.emailFormatError = true;
        $('#email-format-error').show();
      }

    }

  }

  redirectToHome() {
    if (this.httpService.isLocalAuthenticated() === true) {
      this.router.navigate(['/feed']);
    } else {
      if (this.router.url !== '/') {
        this.router.navigate(['/']);
      } else {
        $('.banner .flexInput input').focus();
      }
    }
  }


  /**
   * Login with minimal permissions. This allows you to see their public profile only.
   */
  getFriends() {
    const loginOptions: LoginOptions = {
      enable_profile_selector: true,
      return_scopes: true,
      scope: 'public_profile,user_friends,email'
    };


    this.fbook.login(loginOptions)
      .then((res: LoginResponse) => {
        // console.log('Logged in', res);
        // accessToken
        // userID
        if (res) {
          // this.getUserFriends();
          this.sharePost();
        }

      })
      .catch();
  }

  sharePost() {
    const params: UIParams = {
      method: 'send',
      name: 'This is the content of the "name" field.',
      link: environment.apiUrl + 'feed',
      description: 'This is the content of the "description" field, below the caption.',
    };

    this.fbook.ui(params)
      // .then((res: UIResponse) => console.log(res))
      .catch((e: any) => console.error(e));
  }

  mobileToggle() {
    if ($(window).innerWidth() < 481) {
      if (($('.main_container .side_panel').css('left')) == '-200px') {
        $('.main_container .side_panel').css({ 'left': 0, 'width': '100%' });
        $('#mobile_menu_switch,#mobile_menu_switch1').addClass('view');
      } else {
        $('.main_container .side_panel').css({ 'left': '-200px', 'width': '200px' });
        $('#mobile_menu_switch,#mobile_menu_switch1').removeClass('view');
      }
    } else {
      if (($('.main_container .side_panel').css('left')) === '-200px') {
        $('.main_container .side_panel').css({ 'left': 0, 'width': '200px' });
      } else {
        $('.main_container .side_panel').css({ 'left': '-200px', 'width': '200px' });
      }
    }
    $('.main_container #mobile_menu_switch,#mobile_menu_switch1').toggleClass('active');
  }
  mobileToggleClose(type = null) {
    $('body').find('#side_menu li').removeClass('view');
    switch (type) {
      case 'post':
        $('body').find('#side_menu .feed').addClass('view');
        break;
      case 'maint':
        setTimeout(() => {
          $('body').find('#side_menu li').removeClass('view');
          $('body').find('#side_menu .maintenanceIco').addClass('view');
        }, 500);
        break;
      case 'msg':
        $('body').find('#side_menu .msg').addClass('view');
        break;
      case 'alert':
        $('body').find('#side_menu .alrt').addClass('view');
        break;
      default: break;
    }
    $('.main_container .side_panel').css({ 'left': '-200px', 'width': '200px' });
    $('#mobile_menu_switch,#mobile_menu_switch1').removeClass('view');
    $('.main_container #mobile_menu_switch,#mobile_menu_switch1').removeClass('active');
  }

  accountUpgrade() {
    this.upgradeService.userSetup(this.id);
  }
  showAllBuildings() {
    $('#all_building_drp1').toggle();
  }
  selectedBuilding(build) {
    this.alert = null;
    this.finalBuilding = build;
  }


}
